import type { ReactNode } from 'react';
import { Flex } from '../../../../flex';
import { Text } from '../../../../typography';
import styles from './message-preview.module.css';

export type MessagePreviewProperties = {
  author?: string;
  message: { icon?: ReactNode; text: string } | string;
  unread?: boolean;
};

const MessagePreview = ({ author, message, unread }: MessagePreviewProperties) => {
  const textType = unread ? 'primary' : 'secondary';

  return (
    <Flex align="center" className={styles.message} gap="xxxs">
      {author ? (
        <Text className={styles.author} size="small" type={textType}>
          {`${author}:`}
        </Text>
      ) : null}
      {typeof message === 'string' ? (
        <Text className={styles.message} ellipsis size="small" type={textType}>
          {message}
        </Text>
      ) : (
        <Flex align="center" className={styles.message} gap="xxxs">
          {message.icon ? <Text type={textType}>{message.icon}</Text> : null}
          <Text className={styles.message} ellipsis size="small" type={textType}>
            {message.text}
          </Text>
        </Flex>
      )}
    </Flex>
  );
};

export default MessagePreview;
